var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWalletConnect3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.28037 9.99214C10.638 5.67157 17.7015 5.67157 22.0647 9.99214L22.589 10.5115C22.8088 10.7284 22.8088 11.0766 22.589 11.2934L20.7963 13.0742C20.6892 13.1826 20.5088 13.1826 20.4017 13.0742L19.6801 12.3608C16.6417 9.34719 11.709 9.34719 8.67056 12.3608L7.89826 13.1256C7.79115 13.234 7.61076 13.234 7.50365 13.1256L5.70537 11.3448C5.48551 11.1279 5.48551 10.7798 5.70537 10.5629L6.28037 9.99214ZM25.774 13.6678L27.3694 15.2487C27.5892 15.4656 27.5892 15.8138 27.3694 16.0307L20.1706 23.1707C19.9507 23.3876 19.6012 23.3876 19.3814 23.1707L14.2684 18.1025C14.212 18.0511 14.1274 18.0511 14.0711 18.1025L8.9637 23.1707C8.74385 23.3876 8.39434 23.3876 8.17449 23.1707L0.970066 16.0364C0.750212 15.8195 0.750212 15.4713 0.970066 15.2545L2.56541 13.6735C2.78526 13.4566 3.13477 13.4566 3.35463 13.6735L8.46762 18.7417C8.524 18.7931 8.60856 18.7931 8.66493 18.7417L13.7723 13.6735C13.9921 13.4566 14.3417 13.4566 14.5615 13.6735L19.6745 18.7417C19.7309 18.7931 19.8154 18.7931 19.8718 18.7417L24.9848 13.6735C25.199 13.4509 25.5542 13.4509 25.774 13.6678Z",
    fill: "#3A99FB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletConnect3);
export default __webpack_public_path__ + "static/media/WalletConnect 3.360a342b1ed4bf8d1089cab9d01e4644.svg";
export { ForwardRef as ReactComponent };